// removed by extract-text-webpack-plugin
module.exports = {"PurchaseHeader":"PurchaseHeader__PurchaseHeader__2fHEg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tracker/PurchaseHistory/PurchaseHeader/PurchaseHeader.css
// module id = 66
// module chunks = 0